<template lang="pug">
  money(
    v-model="money"
    class="sosInput"
    :disabled="disabled"
    v-bind="configCurrency"
    @input="onInput"
    @focus.native="onFocus($event)"
    @blur.native="onBlur"
  )
</template>

<script>
  import { Money } from 'v-money'

  export default {
    name: 'AppMoneyLight',
    components: { Money },
    props: {
      // label: { type: String, required: true },
      value: { type: [Number, String], required: true },
      options: { type: Object, default: () => ({}) },
      blurEvent: { type: Function, required: true, default: () => ({}) },
      disabled: { type: Boolean, default: false },
    },
    data () {
      return {
        configCurrency: { decimal: ',', thousands: '.', prefix: 'R$ ', precision: 2, maxlength: 13, masked: false, ...this.options },
        money: 0,
        input_active: false,
      }
    },
    watch: {
      value (val) {
        this.money = parseFloat(val) + 0.001
      },
    },
    created () {
      this.money = parseFloat(this.value) + 0.001
    },
    methods: {
      onInput (event) {
        this.$emit('input', this.money)
      },
      onFocus (event) {
        event.target.select()
        this.input_active = true
      },
      onBlur (event) {
        this.input_active = false
        this.blurEvent(this.money)
      },
    },
  }
</script>
